var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "atmo-content-group" },
    [
      _c(
        "AccordionItem",
        {
          staticClass: "pb-0",
          attrs: {
            visible: _vm.$route.hash === "#second-proposal-contract",
            title: "Предложить заключить контракт второму поставщику",
            "header-class": "fs-22",
          },
        },
        [
          _c("fl44-unknown-volume-select-second-proposal-table", {
            attrs: {
              proposals:
                _vm.purchase.customer_select_second_proposal_data
                  .actual_proposals,
              v: _vm.$v.form.selected_proposal_id,
            },
            model: {
              value: _vm.form.selected_proposal_id,
              callback: function ($$v) {
                _vm.$set(_vm.form, "selected_proposal_id", $$v)
              },
              expression: "form.selected_proposal_id",
            },
          }),
          _vm.form.selected_proposal_id
            ? [
                _c("h5", { staticClass: "grey-color fw-600" }, [
                  _vm._v("Информация о выбранном поставщике"),
                ]),
                _c("text-row-link", {
                  attrs: {
                    compact: "",
                    label: "Наименование",
                    "router-link": {
                      name: "OrganizationShow",
                      params: { id: _vm.selectedProposal.organization.id },
                    },
                  },
                  model: {
                    value: _vm.selectedProposal.organization.full_name,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.selectedProposal.organization,
                        "full_name",
                        $$v
                      )
                    },
                    expression: "selectedProposal.organization.full_name",
                  },
                }),
                _c("text-row", {
                  attrs: { compact: "", label: "ИНН" },
                  model: {
                    value: _vm.selectedProposal.organization.inn,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedProposal.organization, "inn", $$v)
                    },
                    expression: "selectedProposal.organization.inn",
                  },
                }),
                _c("text-row", {
                  attrs: { compact: "", label: "КПП" },
                  model: {
                    value: _vm.selectedProposal.organization.kpp,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedProposal.organization, "kpp", $$v)
                    },
                    expression: "selectedProposal.organization.kpp",
                  },
                }),
                _c("text-row", {
                  attrs: { compact: "", label: "ОГРН" },
                  model: {
                    value: _vm.selectedProposal.organization.ogrn,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedProposal.organization, "ogrn", $$v)
                    },
                    expression: "selectedProposal.organization.ogrn",
                  },
                }),
                _c("text-row-single-document", {
                  attrs: { compact: "", label: "Карточка предприятия" },
                  model: {
                    value: _vm.selectedProposal.organization_card,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedProposal, "organization_card", $$v)
                    },
                    expression: "selectedProposal.organization_card",
                  },
                }),
                _c("text-row", {
                  attrs: { compact: "", label: "Рейтинг ИС" },
                  model: {
                    value: _vm.selectedProposal.organization.rating,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedProposal.organization, "rating", $$v)
                    },
                    expression: "selectedProposal.organization.rating",
                  },
                }),
                _vm.selectedProposal.commercial_proposal
                  ? _c("text-row-single-document", {
                      attrs: { compact: "", label: "Коммерческое предложение" },
                      model: {
                        value: _vm.selectedProposal.commercial_proposal,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectedProposal,
                            "commercial_proposal",
                            $$v
                          )
                        },
                        expression: "selectedProposal.commercial_proposal",
                      },
                    })
                  : _vm._e(),
                _vm.selectedProposal.documents > 0
                  ? _c("text-row-documents", {
                      attrs: {
                        compact: "",
                        label:
                          "Дополнительные документы, приложенные поставщиком к предложению",
                      },
                      model: {
                        value: _vm.selectedProposal.documents,
                        callback: function ($$v) {
                          _vm.$set(_vm.selectedProposal, "documents", $$v)
                        },
                        expression: "selectedProposal.documents",
                      },
                    })
                  : _vm._e(),
                _c(
                  "text-row-raw",
                  {
                    attrs: {
                      label: "Требования к участникам закупки",
                      compact: "",
                    },
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "fs-14 grey-color my-auto col-form-label",
                      },
                      [
                        _vm.selectedProposal.supplier_requirements_confirmed
                          .supplier_reqs_a
                          ? _c("li", [
                              _c("i", { staticClass: "atmo-icon-checkbox" }),
                              _vm._v(
                                " Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                              ),
                              _c(
                                "ul",
                                [
                                  _c("li", [
                                    _vm._v(
                                      "Документы, подтверждающие соответствие требованиям:"
                                    ),
                                  ]),
                                  _vm._l(
                                    _vm.selectedProposal
                                      .supplier_requirements_confirmed
                                      .supplier_required_documents,
                                    function (document, index) {
                                      return _c("li", { key: index }, [
                                        _c("ul", { staticClass: "ml-3" }, [
                                          _c("li", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  `${index + 1}. ${
                                                    document.name
                                                  } - `
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "fs-14 atmo-button-link",
                                                attrs: {
                                                  href: _vm.$getAttachmentDownloadLink(
                                                    document.storedDocument.id
                                                  ),
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    document.storedDocument.name
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                        _vm.selectedProposal.supplier_requirements_confirmed
                          .supplier_reqs_b
                          ? _c("li", [
                              _c("i", { staticClass: "atmo-icon-checkbox" }),
                              _vm._v(
                                " Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                              ),
                            ])
                          : _vm._e(),
                        _vm.selectedProposal.supplier_requirements_confirmed
                          .supplier_reqs_c
                          ? _c("li", [
                              _c("i", { staticClass: "atmo-icon-checkbox" }),
                              _vm._v(
                                " Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ. "
                              ),
                            ])
                          : _vm._e(),
                        _vm.selectedProposal.supplier_requirements_confirmed
                          .supplier_reqs_sonko
                          ? _c("li", [
                              _c("i", { staticClass: "atmo-icon-checkbox" }),
                              _vm._v(" Поставщик подтвердил, что является "),
                              _c(
                                "abbr",
                                {
                                  attrs: {
                                    title:
                                      "Социально ориентированная некоммерческая организация",
                                  },
                                },
                                [_vm._v("СОНКО")]
                              ),
                              _vm._v("."),
                            ])
                          : _vm._e(),
                        !!_vm.selectedProposal.supplier_requirements_confirmed
                          .additional_requirements &&
                        _vm.selectedProposal.supplier_requirements_confirmed
                          .additional_requirements.length > 0
                          ? _c("li", [
                              _c("i", { staticClass: "atmo-icon-checkbox" }),
                              _vm._v(
                                " Поставщик подтвердил соответствие дополнительным требованиям приложив следующие документы: "
                              ),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.selectedProposal
                                    .supplier_requirements_confirmed
                                    .additional_requirements,
                                  function (requirement, index) {
                                    return _c("li", { key: index }, [
                                      _c("ul", { staticClass: "ml-3" }, [
                                        _c("li", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                `${index + 1}. ${
                                                  requirement.description
                                                } (Причина: ${
                                                  requirement.reason
                                                }) - `
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "fs-14 atmo-button-link",
                                              attrs: {
                                                href: _vm.$getAttachmentDownloadLink(
                                                  requirement.attachment.id
                                                ),
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  requirement.attachment.name
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _c("text-row-proposal-specification-table", {
                  attrs: { "without-vat": _vm.selectedProposal.without_vat },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "fs-14 fw-600",
                                staticStyle: { "padding-left": "5px" },
                              },
                              [_vm._v("Спецификация:")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2424351103
                  ),
                  model: {
                    value: _vm.selectedProposal.deliverables,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedProposal, "deliverables", $$v)
                    },
                    expression: "selectedProposal.deliverables",
                  },
                }),
                _vm.features.kbk_limits &&
                !_vm.purchase.purchase_terms.without_limits
                  ? _c("limits-editable-table", {
                      attrs: {
                        "total-cost":
                          _vm.purchase.purchase_terms.contract_price,
                        "limit-year":
                          _vm.purchase.purchase_terms.purchase_limit_year,
                        "order-type": _vm.purchase.purchase_terms.order_type,
                        "purchase-type": "fl44_unknown_volume",
                        "purchase-id": _vm.purchase.id,
                      },
                      on: { validate: _vm.limitsValidate },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("h5", { staticClass: "grey-color fw-600" }, [
                                  _vm._v("Измените лимиты"),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "label-hint",
                            fn: function () {
                              return [
                                _vm._v(
                                  " Добавьте или измените лимиты. Необходимо полностью распределить цену контракта по соответствующим лимитам. "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2819952755
                      ),
                      model: {
                        value: _vm.form.limits,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "limits", $$v)
                        },
                        expression: "form.limits",
                      },
                    })
                  : _vm._e(),
                _c("form-row-contract-upload", {
                  attrs: {
                    "label-cols-lg": 3,
                    v: _vm.$v.form.contract_attachment,
                    "send-title": "Отправить контракт",
                    title: "Контракт",
                  },
                  model: {
                    value: _vm.form.contract_attachment,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contract_attachment", $$v)
                    },
                    expression: "form.contract_attachment",
                  },
                }),
                _c(
                  "b-overlay",
                  {
                    staticClass: "d-inline-block",
                    attrs: {
                      show: _vm.isDataSending,
                      opacity: "0.6",
                      rounded: "",
                      "spinner-small": "",
                      "spinner-variant": "primary",
                    },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "text-uppercase ml-1",
                        attrs: {
                          disabled: !_vm.isValid,
                          variant: "custom-green",
                        },
                        on: { click: _vm.storeSecondContract },
                      },
                      [_vm._v("Отправить контракт")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }